module.exports = __webpack_public_path__ + "static/318503382_666026165193822_1805355563868328223_n.jpg-1671186393568_512-86a36327da41cd88e9871a80522b991a.webp";